export default __webpack_public_path__ + "static/media/Wanderlust3.b72f7fea.png";